import React from 'react'

const AccordionItem = props => {
  return (
    <div className="accordion-item">
      {props.children}
    </div>
  )
}

export default AccordionItem;
